import classNames from "classnames";
import styles from "./style.module.scss";

interface InputProps extends React.HTMLProps<HTMLInputElement> {
  label: string;
  required: boolean;
  error: string;
  placeholder: string;
  onChange: any;
  customLabelStyle: any;
  customInputStyle: any;
  customInputContainer: any;
  limit?: number;
  showLimit?: boolean;
  onPaste: any;
}

const CustomTextArea = ({
  label,
  required,
  error,
  value,
  placeholder,
  onChange,
  customLabelStyle,
  customInputStyle,
  customInputContainer,
  limit,
  showLimit,
  disabled,
  onPaste,
}: Partial<InputProps>) => {
  const charLimit = limit ? limit : 3000;
  return (
    <div className="relative mb-3 w-full">
      <div className="flex flex-col items-start w-full gap-2">
        {label ? (
          <label
            className={classNames(
              styles.inputLabel,
              customLabelStyle && customLabelStyle
            )}
          >
            {label} {!!required && <label className={styles.asterik}>*</label>}
          </label>
        ) : null}

        <div
          className={classNames(
            customInputContainer && customInputContainer,
            styles.inputContainer,
            "w-full"
          )}
        >
          <textarea
            onChange={onChange}
            placeholder={placeholder}
            className={classNames(
              styles.inputStyle,
              customInputStyle && customInputStyle
            )}
            value={value}
            disabled={disabled}
            onPaste={onPaste}
          />
        </div>
      </div>
      {!!error ? (
        <div className={styles.error}>{error}</div>
      ) : showLimit ? (
        <label className={classNames(styles.lmtLabel)}>
          {Number(charLimit - String(value ? value : "").length)} characters left
        </label>
      ) : null}
    </div>
  );
};

export default CustomTextArea;
